export default "__VITE_ASSET__DqNnBBbs__"